import React, { useEffect }  from 'react';

function LanguageSelector({ supportedLanguages = [], defaultLanguage, language }) {

	useEffect(() => {
		window.applicationReInit(['Dropdown']);
	}, [supportedLanguages]);

	
	if (supportedLanguages.length <= 1) {
		return null;
	}
	
	const currentLanguage = supportedLanguages.find(lang => lang.code === language) || defaultLanguage;


	return (
		<div className="c-header-metabar__language">
			<div className="c-header-dropdown" data-toggle-switcher="dropdown">
				{/* eslint-disable-next-line */}
				<a className="c-header-dropdown__toggle" href="#" aria-haspopup="true" aria-expanded="false" aria-describedby="dropdownID2" data-trigger-switcher="dropdown" role="button">
					{currentLanguage ? currentLanguage.name : 'Language not found'}
					<i className="c-icon c-icon--chevron-down c-header-dropdown__icon"></i>
				</a>

				<ul className="c-header-dropdown__menu" role="menu" aria-hidden="true" data-items-switcher="dropdown">
					{supportedLanguages.map((lang, index) => (
						<li key={index} className={`c-header-dropdown__item ${currentLanguage && lang.code === currentLanguage.code ? "checked" : ""}`}>
							<a href={`/${lang.code}`} role="menuitem">{lang.name}</a>
						</li>
					))}
				</ul>
			</div>
		</div>

	);
}

export default LanguageSelector;